import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    creatorProfilePlatformTab: "profileDetails",
    creatorProfileSectionTab: "engagements",
    pricingDetailsTab: "pricingDetails",
    creatorDetailsFormTab: "contactDetails",
    creatorData: {},
    platformData: {},
    currentBrand: "All Brands",
    similarCreatorsData: [],
    creatorNotesData: [],
    creatorBasedPlatformData: []
}
const creatorProfileSlice = createSlice({
    name: "creatorProfile",
    initialState,
    reducers: {
        setCreatorProfilePlatformTab(state, action) {
            state.creatorProfilePlatformTab = action?.payload
        },
        setCreatorProfileSectionTab(state, action) {
            state.creatorProfileSectionTab = action?.payload
        },
        setPricingDetailsTab(state, action) {
            state.pricingDetailsTab = action?.payload
        },
        setCreatorDetailsFormTab(state, action) {
            state.creatorDetailsFormTab = action?.payload
        },
        clearCreatorProfile(state, action) {
            return initialState;
        },
        setCreatorProfileSlice(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
        setCreatorProfile(state, action) {
            state.creatorData = action?.payload
        },
        setCreatorNotes(state, action) {
            state.creatorNotesData = action?.payload
        },
        setPlatformData(state, action) {
            state.platformData = action?.payload
        }
    }

})

export const creatorProfileActions = creatorProfileSlice.actions;

export default creatorProfileSlice;
